// This class is to handle global events (ge)
// which are outside the scope of Asta 
// For Asta events we use db.js 
// => in this way we can easily remove all listeners when asta is destroyed
import EventEmitter from 'events'
// import firebase from '../../config-firebase/firebase'
import {
  databaseShared
} from '../../config-firebase/firebase'
import {
  ref, off, onValue
} from "firebase/database";
import store from '../store'
import * as types from '../store/mutations-types'

// let versionRef = firebase.databaseShared.ref('version');
const versionRef = ref(databaseShared, 'version');
// let astaonlineRef = firebase.database.ref('asta-online');

class GlobalEvent extends EventEmitter {
  constructor() {
    super()
  }
  fetchVersion() {
    off(versionRef);
    onValue(versionRef, (snapshot) => {
      let version = snapshot.val() || {};
      this.emit("fetchedVersion", version)
    });
  }
}

export default new GlobalEvent()
